import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Icon, Text } from '../../../../../../components';
import {
  BackButton,
  InteractiveButton,
  ToggleCard
} from '../../../../components';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line.svg';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/registerChangePhotoUseCase';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import LightBox from '../../../../../../components/LightBox';
import Processing from '@/presentation/components/Processing';
import Spinner from '../../../../../../components/Spinner';
import Step from './components/Step';
import constants from '../../../../constants/index';
import ModalConfirmation from '../../../../components/Modal/Modal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import routes from '../../../../../../components/Routes/routingMap';
import closeIcon from '../../../../../../../assets/icons/icon-close-red.svg';
import ConfirmationQuit from './components/ConfirmationQuit';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { FormPhoto } from '@/presentation/reusables/Form';
import { List } from '@/presentation/reusables/components/List';
import ContentModalOneButton from '@/presentation/modules/procedures/components/ContentModalOneButton';
import errorIcon from '../../../../../../../assets/icons/illustration.svg';
import ProgressBody from '../components/ProgressBody';

const UpdatePhotoRegisterViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const profilePhoto = useSelector((state: any) => state.profilePhoto.data);

  const procedureSelectedInfo = useSelector(
    (state: any) => state.procedureInformation?.procedure
  );

  const { isLoading, requestId, error, isSuccess } = useSelector(
    (state: any) => state.registerChangePhoto
  );

  useEffect(() => {
    if (!procedureSelectedInfo)
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.updatePhoto
        )
      );
  }, []);

  const [setTrashFiles]: any = useState(false);
  const [contentLightBox, setContentLightBox]: any = useState(null);
  const [isLightBoxOpen, setLightBoxOpen] = useState(false);
  const [isQuit, setIsQuit] = useState(false);
  const [fileExists, setFileExists] = useState(false);

  const handleLightBox = (status: boolean, content: any) => {
    setContentLightBox(content);
    setLightBoxOpen(status);
  };

  const handleClear = () => {
    dispatch(registerActions.registerUpdatePhotoClear());
  };

  const onRegister = (src?: string) => {
    if (src) {
      const base64 = src.split(',')[1];
      dispatch(registerActions.registerChangePhoto(base64, 'jpg'));
    }
  };

  const handleGoToExists = () => {
    dispatch(
      requestStatusActions.getStudentProcedureStatus(
        procedureSelectedInfo?.procedureId ||
          constants.categories.requests.procedures.updatePhoto,
        requestId
      )
    );
    history.push(
      routes.student.procedures.categories.requests.updatephoto
        .procedureprogress
    );
  };
  const handleBack = () => {
    if (error === 'EXCEDISTE' || error === 'TIMEOUT' || error === 'SFTP ERROR')
      history.push(routes.student.procedures.home);
    else dispatch(registerActions.registerChangePhotoClear());
  };
  if (requestId && isSuccess) {
    dispatch(
      requestStatusActions.getStudentProcedureStatus(
        constants.categories.requests.procedures.updatePhoto,
        requestId
      )
    );
    history.push(
      routes.student.procedures.categories.requests.updatephoto
        .procedureprogress
    );
  }
  return (
    <ContainerProcedure>
      <Block customized alignItems="center" justifyContent="center">
        {!procedureSelectedInfo && <Spinner />}
        {procedureSelectedInfo && (
          <SubContainer>
            <Block customized justifyContent="flex-start" margin="0px 0px 16px">
              <BackButton
                onClick={() => {
                  if (fileExists) setIsQuit(true);
                  else
                    history.push(
                      routes.student.procedures.categories.requests.updatephoto
                        .procedureinfo
                    );
                }}
              />
            </Block>
            <ToggleCard>
              {/* {toggleTitle} */}
              <Text
                color="#161D1F"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="900"
              >
                {procedureSelectedInfo?.name}
              </Text>
              <Block
                customized
                flexDirection="row"
                alignItems="center"
                margin="0px 0px 12px 0px"
              >
                <ProgressBody
                  moneyIcon={moneyIcon}
                  procedureSelectedInfo={procedureSelectedInfo}
                  lineIcon={lineIcon}
                  clockIcon={clockIcon}
                />
              </Block>
              <List />
            </ToggleCard>
            {/* Progreso */}
            <Heading
              text="Progreso"
              level={2}
              color="var(--text-text02)"
              size={18}
              lineHeight={28}
              fontWeight="900"
              className=""
              align="flex-start"
            />
            <Block
              customized
              maxWidth="100%"
              padding={isMobile ? '28px 0px 52px 8px' : '28px 0px 45px 16px'}
            >
              <Step
                // name={procedureSelectedInfo.steps[0].name}
                name="Registrar solicitud"
                order={procedureSelectedInfo.steps[0].order}
                isCurrent
              >
                <FormPhoto
                  isValid={location?.search.split('=')[1]}
                  photo={profilePhoto}
                  hasPhoto={procedureSelectedInfo.hasPhoto}
                  onRegister={onRegister}
                  setFileExists={setFileExists}
                />
              </Step>
              <Step
                name={procedureSelectedInfo.steps[1].name}
                order={procedureSelectedInfo.steps[1].order}
                isLast
                disabled
              />
            </Block>
          </SubContainer>
        )}
      </Block>
      <LightBox IsModalOpen={isLightBoxOpen} autoCloseLayer>
        <Block
          width="100%"
          customized
          flexDirection="row"
          justifyContent="flex-end"
          padding="8px 4px 0px"
        >
          <InteractiveButton
            bkgColorEnabled="none"
            bkgColorHover="#FED4D6"
            bkgColorFocus="#FDADB3"
            bkgColorPressed="#FDADB3"
            borderRadius="4px"
            customized
            onClick={() => {
              handleLightBox(false, null);
              setTrashFiles(true);
            }}
          >
            <Icon
              customized
              minWidth="40px"
              height="40px"
              alignItems="center"
              justifyContent="center"
            >
              {/* <Icon name="x" size={28} /> */}
              <img src={closeIcon} alt="other" />
            </Icon>
          </InteractiveButton>
        </Block>
        {contentLightBox}
      </LightBox>
      <Processing isOpen={isLoading} />
      <ModalConfirmation
        show={error && requestId}
        handleClose={() => handleClear()}
      >
        <RequestExist handleClick={handleGoToExists} />
      </ModalConfirmation>
      {error === 'TIMEOUT' ? (
        <ModalConfirmation show={error} handleClose={handleBack}>
          <ContentModalOneButton
            title="Envío en proceso"
            subtitle="Podrás visualizar tu solicitud en el historial de trámites en unos minutos."
            showInfo={false}
            textButton="Ir al historial"
            onClickButton={handleBack}
          />
        </ModalConfirmation>
      ) : (
        <ModalConfirmation show={error} handleClose={handleBack}>
          <ContentModalOneButton
            center
            img={errorIcon}
            title={
              error === 'EXCEDISTE'
                ? 'El registro de foto ya se realizó con éxito este año.'
                : '¡Oh no!<br/>Ha sucedido un error inesperado'
            }
            showInfo={false}
            textButton="Entendido"
            onClickButton={handleBack}
          />
        </ModalConfirmation>
      )}

      <ModalConfirmation
        show={isQuit}
        handleClose={() => {
          setIsQuit(false);
        }}
      >
        <ConfirmationQuit
          handleQuit={() => {
            history.push(
              routes.student.procedures.categories.requests.updatephoto
                .procedureinfo
            );
          }}
          handleCancel={() => {
            setIsQuit(false);
          }}
        />
      </ModalConfirmation>
    </ContainerProcedure>
  );
};

export default UpdatePhotoRegisterViewController;
